import { Box, Grid, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import NonProgressBar from '../../../components/NonProgressBar';
import { EmergencyGroup } from '../../../schema/emergency';
import { api } from '../../../api';

interface EmergencyInfo {
  handleOnClickInfo: (roleId: number | string) => void;
  handleOnClickExport: (roleId: number | string) => void;
}

const EmergencyInfo = ({ handleOnClickInfo, handleOnClickExport }: EmergencyInfo) => {
  const [mainEmergencyGroupList, setMainEmergencyGroupList] = useState<EmergencyGroup[]>([]);
  const [subEmergencyGroupList, setSubEmergencyGroupList] = useState<EmergencyGroup[]>([]);

  useEffect(() => {
    api.get<EmergencyGroup[]>(`/emergency/group`, { params: { is_main: true } }).then((res) => {
      const { data } = res;
      setMainEmergencyGroupList(data);
    });
    api.get<EmergencyGroup[]>(`/emergency/group`, { params: { is_main: false } }).then((res) => {
      const { data } = res;
      setSubEmergencyGroupList(data);
    });
  }, []);

  return (
    <Box sx={{ mt: 3 }}>
      <Grid container columns={mainEmergencyGroupList.length} spacing={3}>
        {mainEmergencyGroupList.map((data, index) => (
          <Grid item xs={1} key={index}>
            <Paper sx={{ padding: 2 }}>
              <Typography variant="h6">{data.group_name}</Typography>
              {data.roles.map((item, index) => (
                <NonProgressBar
                  key={index}
                  name={item.role_name}
                  total={item.total}
                  color="#20ccf5"
                  bgColor="#c2f3ff"
                  // handleOnClickPdf={() => console.log('pdf')}
                  handleOnClickExcel={() => handleOnClickExport(item.id)}
                  handleOnClickInfo={() => handleOnClickInfo(item.id)}
                  // handleOnClick={() => setOpen(true)}
                />
              ))}
            </Paper>
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={3} columns={subEmergencyGroupList.length} mt={3}>
        {subEmergencyGroupList.map((data, index) => (
          <Grid item xs={1} key={index}>
            <Paper sx={{ padding: 2 }}>
              <Typography variant="h6">{data.group_name}</Typography>
              {data.roles.map((item, index) => (
                <NonProgressBar
                  key={index}
                  name={item.role_name}
                  total={item.total}
                  // handleOnClickPdf={() => console.log('pdf')}
                  handleOnClickExcel={() => handleOnClickExport(item.id)}
                  handleOnClickInfo={() => handleOnClickInfo(item.id)}
                />
              ))}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default EmergencyInfo;
